export const environment = {
  apiDomain: 'https://api.eriksen-randers.dk',
  popularCategoriesMenuId: '370',
  popularProductsCategoryKey: 'populaere-produkter',
  primaryNavigationId: '199',
};
